export default "__VITE_ASSET___7VVA6MB__"